import React from 'react'
import Head from 'next/head'

import Layout from 'app/GNNPage/components/Layout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import Home from 'app/GNNPage/pages/Home'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: ['gnn-page-enabled'],
  async serverProps(_, toggle) {
    if (!toggle?.['gnn-page-enabled']) {
      return {
        notFound: true,
      }
    }
  },
})

const GNNLandingPage = () => {
  return (
    <>
      <Head>
        <title>Gerakan Numerasi Nasional</title>
      </Head>
      <Home />
    </>
  )
}

GNNLandingPage.Layout = Layout

export default GNNLandingPage
